import cookies from 'js-cookie';

import {undef} from './undef';
import {hasValidDates} from './dates';

const STATE_COOKIE_NAME = 'ha-state-prst';
const TRIP_COOKIE_NAME = 'ha-trip-prst';
const CHILDREN_AGE_COOKIE_NAME = 'ha-children-age-prst';

function getStateCookieDestinationValues(stateCookieData) {
    if (stateCookieData) {
        const {
            lbsKeywords
        } = stateCookieData;

        if (lbsKeywords) {
            const destination = lbsKeywords.replace(/\+/g, ' ');

            return {
                destination
            };
        }
    }

    return {};
}

function getTripCookieDatesValues(tripCookieData) {
    if (tripCookieData) {
        const {
            arrival: startDate,
            departure: endDate
        } = tripCookieData;

        if (hasValidDates(startDate, endDate)) {
            return {
                startDate,
                endDate
            };
        }
    }

    return {};
}

function getChildrenAgeCookieValues(childrenAgeCookieData) {
    let ageData = [];
    if (childrenAgeCookieData && childrenAgeCookieData.childrenAges) {
        ageData = childrenAgeCookieData.childrenAges.map((age) => {
            return ({
                value: age
            });
        });
    }
    return ageData;
}

// eslint-disable-next-line complexity
function getTripCookieGuestsValues(cookieData) {
    let {tripCookieData, childrenAgeCookieData} = cookieData;
    if (tripCookieData) {
        let {
            numberOfAdults,
            numberOfChildren,
            numberOfBedrooms,
            petIncluded
        } = tripCookieData;
        let ageData = undef;

        numberOfAdults = parseInt(numberOfAdults, 10);
        numberOfAdults = !isNaN(numberOfAdults) ? numberOfAdults : undef;

        if (numberOfAdults === 0 || numberOfAdults === undef) {
            return {};
        }

        numberOfChildren = parseInt(numberOfChildren, 10);
        numberOfChildren = !isNaN(numberOfChildren) ? numberOfChildren : undef;

        numberOfBedrooms = parseInt(numberOfBedrooms, 10);
        numberOfBedrooms = !isNaN(numberOfBedrooms) ? numberOfBedrooms : undef;

        if (numberOfChildren) {
            ageData = getChildrenAgeCookieValues(childrenAgeCookieData);
        }

        petIncluded = (typeof petIncluded === 'string') ? petIncluded === 'true' : petIncluded;

        return {
            adultsCount: numberOfAdults,
            childrenCount: numberOfChildren,
            bedroomsCount: numberOfBedrooms,
            ageData,
            petIncluded
        };
    }

    return {};
}

function getSearchCookies() {
    const stateCookieData = cookies.getJSON(STATE_COOKIE_NAME);
    const tripCookieData = cookies.getJSON(TRIP_COOKIE_NAME);
    const childrenAgeCookieData = cookies.getJSON(CHILDREN_AGE_COOKIE_NAME);

    const destinationValues = getStateCookieDestinationValues(stateCookieData);
    const datesValues = getTripCookieDatesValues(tripCookieData);
    const guestsValues = getTripCookieGuestsValues({tripCookieData, childrenAgeCookieData});

    return {
        destinationValues,
        datesValues,
        guestsValues
    };
}

function removeCookieKeys(name, keys) {
    const data = cookies.getJSON(name);

    if (data) {
        for (const key of keys) {
            delete data[key];
        }

        cookies.set(name, data);
    }
}

function removeTripCookieChildrenAges() {
    removeCookieKeys(CHILDREN_AGE_COOKIE_NAME, ['childrenAges']);
}

function removeTripCookieDates() {
    removeCookieKeys(TRIP_COOKIE_NAME, ['arrival', 'departure']);
}

function setTripCookieChildrenAges(childrenAges) {
    cookies.set(CHILDREN_AGE_COOKIE_NAME, {childrenAges});
}

export {
    STATE_COOKIE_NAME,
    TRIP_COOKIE_NAME,
    CHILDREN_AGE_COOKIE_NAME,
    getSearchCookies,
    removeTripCookieChildrenAges,
    removeTripCookieDates,
    setTripCookieChildrenAges
};
